module.exports = __webpack_public_path__ + "img/secondary.c17700fe.svg";